export default {
  country: {},
  countries: [],
}
